import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Section } from '../components/ui/Section';
import { CTASection } from '../components/sections/CTASection';
import { ArrowRight, Loader2 } from 'lucide-react';
import { useServices } from '../hooks/useServices';
export function ServicesPage() {
  const {
    services,
    loading
  } = useServices();
  return <main className="pt-24" data-id="element-1496">
      <Section background="default" data-id="element-1497">
        <div className="max-w-4xl" data-id="element-1498">
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="text-4xl md:text-5xl lg:text-6xl font-bold font-heading text-[#0C0C0C] mb-6 leading-tight" data-id="element-1499">
            Our Services
          </motion.h1>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.1
        }} className="text-xl text-gray-600 leading-relaxed" data-id="element-1500">
            We design and build digital solutions that align with your business
            goals, user needs, and long-term growth strategy.
          </motion.p>
        </div>
      </Section>

      <Section background="white" data-id="element-1501">
        {loading ? <div className="flex items-center justify-center py-20 text-gray-400" data-id="element-1502">
            <Loader2 className="w-6 h-6 animate-spin mr-3" data-id="element-1503" />
            Loading services…
          </div> : services.length === 0 ? <div className="text-center py-20 text-gray-400" data-id="element-1504">
            <p className="text-lg font-medium" data-id="element-1505">No services available yet.</p>
            <p className="text-sm mt-2" data-id="element-1506">Check back soon!</p>
          </div> : <div className="space-y-24" data-id="element-1507">
            {services.map((service, index) => <motion.div key={service.id} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className={`grid grid-cols-1 lg:grid-cols-2 gap-12 items-stretch ${index % 2 === 1 ? 'lg:flex-row-reverse' : ''}`} data-id="element-1508">
                <div className={`flex flex-col justify-between h-[350px] ${index % 2 === 1 ? 'lg:order-2' : ''}`} data-id="element-1509">
                  <div className="flex-1 min-h-0" data-id="element-1510">
                    <h2 className="text-3xl font-bold font-heading text-[#0C0C0C] mb-4" data-id="element-1511">
                      {service.title}
                    </h2>
                    <p className="text-lg text-gray-600 leading-relaxed line-clamp-6" data-id="element-1512">
                      {service.description}
                    </p>
                  </div>
                  <Link to={`/services/${service.slug}`} className="inline-flex items-center gap-2 text-[#FF6600] font-medium hover:gap-3 transition-all mt-6 shrink-0" data-id="element-1513">
                    Read more
                    <ArrowRight className="w-4 h-4" data-id="element-1514" />
                  </Link>
                </div>

                <div className={`relative h-[350px] rounded-2xl overflow-hidden ${index % 2 === 1 ? 'lg:order-1' : ''}`} data-id="element-1515">
                  {service.image ? <img src={service.image} alt={service.title} className="w-full h-full object-cover" data-id="element-1516" /> : <div className="w-full h-full bg-gradient-to-br from-gray-100 to-gray-200 flex items-center justify-center" data-id="element-1517">
                      <span className="text-4xl font-bold text-gray-200 font-heading" data-id="element-1518">
                        {service.title.charAt(0)}
                      </span>
                    </div>}
                </div>
              </motion.div>)}
          </div>}
      </Section>

      <CTASection data-id="element-1519" />
    </main>;
}